import pub from './../public'
const type = pub.getLang();

const language = {
 "zh-hk": {
  // agentCardTime: '地產代理證到期日',
  agentCardTime: '地產牌照屆滿日期',
  whatsappText: '你好，我想刪除我的House730賬戶',
  companyTips: '上傳後，地產代理證將無法修改 如需修改或無法上傳，請聯絡我們：36193200',
  deleteAccount: '刪除帳戶',
  deletePageTitle: '確認刪除House730帳戶?',
  deletePageInfo1: '刪除帳戶手續一般需要40天處理，當完成後，我們會透過電郵通知您。',
  deletePageInfo2: '如有疑問，請聯絡我們：36193200',
  deleteBtnText: '確定刪除帳戶',
  emailRegistered: '該電郵地址已註冊，無法綁定',
  telError1: "請輸入正確的手提電話",
  telError2: "請輸入正確格式的手提電話",
  editError: '更改失敗',
  smsError: '驗證碼錯誤，請重新輸入',
  confirmPhoto: '確定相片',
  telNotice: '該手提電話已註冊，無法綁定',
  telCodeNotice: '獲取驗證碼次數過多，請稍後再試',
  editEmailNotice: '如需修改電郵地址，請聯絡我們：36193200',
  reSetCode: '後重新獲取',
  newTelJoin: '加入新手提電話',
  oldTelVer: '驗證原手提電話',
  verification: '驗證',
  setPhone: '請輸入手提電話',
  setSMSCode: '請輸入SMS驗證碼',
  getCaptcha: '獲取驗證碼',
  newPhoneJoinSuc: '新手提電話加入成功',
  return: '返回',
  editUserName: '修改會員名稱',
  editNameNoitce: '只能包含中文、英文字母、數字，最多10個字',
  enterNote: '請輸入備註',
  modify: '修改',
  emailAddress: '請輸入電郵地址',
  emailError: '電郵格式錯誤',
  sendEmail: '綁定信息已發送至電郵地址，請點擊電郵內的連結以加入電郵。',
  joinEmail: '電郵地址綁定',
  joinSuccess: '電郵綁定成功',
  backHome: '返回首頁',
  join: '加入',
  setPassword: '設置密碼',
  removePicTitle: '移除後將使用系統默認相片',
  isConfirm: '是否確認繼續?',
  cancel: '取消',
  choosePic: '選擇相片',
  removePic: '移除目前使用的相片',
  newPsdError: '兩次密碼不一致，請重新輸入',
  psdError: '密碼必須為6-20位英文數字組合',
  oldPsdError: '您輸入的舊密碼有誤，請重新輸入',
  editSuccess: "修改成功",
  setPsdSuccess: "新密碼已設置成功",
  forgetPassword: '忘記密碼',
  confirm1: '確定',
  oldPassword: '請輸入舊密碼',
  newPassword: '請輸入6-20位英文數字組合密碼',
  reNewPassword: '請再次確認新密碼',
  changePassword: '修改密碼',
  email: '電郵地址',
  password: '密碼',
  noAgentCardPath: '請上傳代理證',
  notice: '上傳後，地產代理證將無法修改',
  notice1: '如需修改或無法上傳，請聯絡我們：3619 3200',
  agentInformation: '地產代理資料',
  upload: '上傳',
  agentCard: '地產代理證',
  changeMemberProfile: "我的資料",
  success: "修改成功",
  confirm: '確認',
  submit: '提交',
  confirmUpdate: "確定更新",
  userPicture: "個人資料相片",
  registrationEmail: "登記電郵件",
  pleaseFillOut: "請填寫",
  cellPhone: "手提電話",
  memberName: "會員名稱",
  memberNameEn: "會員名稱(英文)",
  acceptInformation: "接收House730會員通訊(Email)",
  acceptSMS: "接收House730短訊(SMS)",
  estateAgent: "持牌地產代理",
  estateAgentNotice: "如閣下是地產代理，請填寫以下資料",
  realEstateAgency: "代理公司名稱(中)",
  realEstateAgencyEN: "代理公司名稱(英)",
  realEstateAgencyPhone: "代理公司電話",
  realEstateAgencyAddress: "代理公司地址",
  estateAgencyLicense: "公司地產代理牌照",
  personalAstateAgencyLicense: "個人地產代理牌照",
  personalAgentSignature: "代理個人署名及介紹",
  noUserName: '請填寫會員名稱',
  noCompanyName: '請填寫代理公司名稱',
  noCompanyTelephone: '請填寫代理公司電話',
  telError: '手機號格式錯誤',
  noCompanyAddress: '請填寫代理公司地址',
  noCompanyLicense: '請填寫公司地產代理牌照號碼',
  noLicense: '請填寫個人代理牌照號碼',
  signature: '代理個人簽名檔',
  fileError: '格式錯誤，只支持png、jpg、jpeg格式',
  picfailure: '上傳頭像失敗',
  fileBig: '圖片太大，檔案大小必須5MB以下',
  fileBig2: '圖片太小，檔案大小必須20KB以上',
  editFailure: '修改失敗',
  login: "登入",
  pleSelect: '請選擇',
 },
 "zh-cn": {
  // agentCardTime: '地产代理证到期日',
  agentCardTime: '地产牌照届满日期',
  whatsappText: '你好，我想删除我的House730账户',
  companyTips: '上传后，地产代理证将无法修改 如需修改或无法上传，请联络我们：36193200',
  deleteAccount: '删除账户',
  deletePageTitle: '确认删除House730账户',
  deletePageInfo1: '删除账户手续一般需要40天处理，当完成后，我们会透过电邮通知您。',
  deletePageInfo2: '如有疑问，请联络我们：36193200',
  deleteBtnText: '确定删除账户',
  emailRegistered: '该电邮地址已注册，无法绑定',
  telError1: "请输入正确的手提电话",
  telError2: "请输入正确的格式手提电话",
  editError: '更改失败',
  smsError: '验证码错误，请重新输入',
  confirmPhoto: '确定相片',
  telNotice: '该手提电话已注册，无法绑定',
  telCodeNotice: '获取验证码次数过多，请稍后再试',
  editEmailNotice: '如需修改电邮地址，请联络我们：36193200',
  reSetCode: '后重新获取',
  newTelJoin: '加入新手提电话',
  oldTelVer: '验证原手提电话',
  verification: '验证',
  setPhone: '请输入手提电话',
  setSMSCode: '请输入SMS验证码',
  getCaptcha: '获取验证码',
  newPhoneJoinSuc: '新手提电话加入成功',
  return: '返回',
  editUserName: '修改会员名称',
  editNameNoitce: '只能包含中文、英文字母、數字，最多10個字',
  enterNote: '请输入备注',
  modify: '修改',
  emailAddress: '请输入电邮地址',
  emailError: '电邮格式错误',
  sendEmail: '绑定信息已发送至电邮地址，请点击电邮内的连结以加入电邮。',
  joinEmail: '电邮地址绑定',
  joinSuccess: '电邮地址绑定成功',
  backHome: '返回首页',
  join: '加入',
  setPassword: '设置密码',
  removePicTitle: '移除将使用系统默认相片',
  isConfirm: '是否确认继续？',
  cancel: '取消',
  choosePic: '选择相片',
  removePic: '移除目前使用的相片',
  newPsdError: '兩次密码不一致，请重新输入',
  psdError: '密码必须为6-20位英文数字组合',
  oldPsdError: '您输入的旧密码有误，请重新输入',
  editSuccess: "修改成功",
  setPsdSuccess: "新密码已设置成功",
  forgetPassword: '忘记密码',
  confirm1: '确定',
  oldPassword: '请输入旧密码',
  newPassword: '请输入6-20位英文数字组合密码',
  reNewPassword: '请再次确认新密码',
  changePassword: '修改密码',
  email: '电邮地址',
  password: '密码',
  noAgentCardPath: '请上传代理证',
  notice: '上传后，地产代理证将无法修改',
  notice1: '如需要修改或无法上传，请联络我们：3619 3200',
  agentInformation: '地产代理资料',
  upload: '上传',
  agentCard: '地产代理证',
  success: "修改成功",
  confirm: '确认',
  submit: '提交',
  changeMemberProfile: "我的资料",
  confirmUpdate: "确定更新",
  userPicture: "个人资料相片",
  pleaseFillOut: "請填寫",
  registrationEmail: "登记电邮",
  cellPhone: "手提电话",
  memberName: "会员名称",
  memberNameEn: "会员名称(英文)",
  acceptInformation: "接收House730会员通讯(Email)",
  acceptSMS: "接收House730短讯(SMS)",
  estateAgent: "持牌地产代理",
  estateAgentNotice: "如阁下是地产代理，请填写以下资料",
  realEstateAgency: "代理公司名称(中)",
  realEstateAgencyEN: "代理公司名称(英)",
  realEstateAgencyPhone: "代理公司电话",
  realEstateAgencyAddress: "代理公司地址",
  estateAgencyLicense: "公司地产代理牌照",
  personalAstateAgencyLicense: "个人地产代理牌照",
  personalAgentSignature: "代理个人署名及介绍",
  noUserName: '请填写会员名称',
  noCompanyName: '请填写代理公司名称',
  noCompanyTelephone: '请填写代理公司电话',
  telError: '手机号格式错误',
  noCompanyAddress: '请填写代理公司地址',
  noCompanyLicense: '请填写公司地产代理牌照号码',
  noLicense: '请填写個人代理牌照',
  signature: '代理个人签名档',
  fileError: '格式错误，只支持png、jpg、jpeg格式',
  picfailure: '上传头像失败',
  fileBig: '图片太大，档案大小必须5MB以下',
  fileBig2: '图片太小，档案大小必须20KB以上',
  editFailure: '修改失败',
  login: "登入",
  pleSelect: '请选择',
 },
 "en-us": {
  pleSelect: 'Please select',
  agentCardTime: 'EAA License Expiry Date',
  whatsappText: 'Hi, I would like to delete my House730 member account',
  companyTips: 'After uploading the Estate Agent Card, it cannot be edited Please contact us if you need assistance：36193200',
  deleteAccount: 'Delete Account',
  deletePageTitle: 'Confirm to delete House730 account?',
  deletePageInfo1: 'Delete account will take 40 days to handle in general. When complete, we will notify you through email.',
  deletePageInfo2: 'If you have any enquiries, please contact us: 36193200',
  deleteBtnText: 'Confirm to delete account',
  emailRegistered: 'Email cannot be connected as it has been registered',
  telError1: "Correct mobile no.",
  telError2: "Correct mobile no.",
  editError: 'Change Failed',
  smsError: 'Incorrect verification code, please enter again',
  confirmPhoto: 'Confirm Photo',
  telNotice: 'Cannot be connected as it has been registered',
  telCodeNotice: 'You have exceeded max. no. of requests, please try again later',
  editEmailNotice: 'If you need to modify your email address, please contact us: 36193200',
  reSetCode: 'Get again after ',
  newTelJoin: 'Add new mobile phone',
  oldTelVer: 'Verify current mobile no.',
  verification: 'Verification',
  setPhone: 'Your mobile no.',
  setSMSCode: 'SMS verification code',
  getCaptcha: 'Get code',
  newPhoneJoinSuc: 'New mobile phone successfully added',
  return: 'Return',
  editUserName: 'Change username',
  editNameNoitce: 'Max.10 characters with alphabets or numbers',
  enterNote: 'Please enter a note',
  modify: 'Edit',
  emailAddress: 'Your email ',
  emailError: 'Correct email format',
  sendEmail: 'Verification email has been sent, please check your email inbox and click the verification link.',
  joinEmail: 'Connect with email',
  joinSuccess: 'Your email address is connected',
  backHome: 'Back To Homepage',
  join: 'Add',
  setPassword: 'Add Password',
  removePicTitle: 'After removal, you will use the default photo',
  isConfirm: 'Continue?',
  cancel: 'Cancel',
  choosePic: 'Choose Photo',
  removePic: 'Remove Current Photo',
  newPsdError: 'Passwords do not match, please enter again',
  psdError: 'The password must be a combination of 6-20 digits in English and numbers',
  oldPsdError: 'The old password you entered is wrong, please re-enter',
  editSuccess: "Password changed",
  setPsdSuccess: "New password is set",
  forgetPassword: 'Forget Password',
  confirm1: 'Continue',
  oldPassword: 'Please enter current password',
  newPassword: 'Please enter 6-20 characters password with alphabets and numbers ',
  reNewPassword: 'Re-enter new password ',
  changePassword: 'Change Password',
  email: 'Email Address',
  password: 'Password',
  noAgentCardPath: 'Please upload Estate Agent Card',
  notice: 'After uploading the Estate Agent Card, it cannot be edited',
  notice1: 'Please contact us if you need assistance：3619 3200',
  agentInformation: 'Property agent information',
  upload: 'Upload',
  agentCard: 'Estate Agent Card',
  success: "Successfully modified",
  confirm: 'Confirm',
  submit: 'Submit',
  changeMemberProfile: "Edit Profile",
  confirmUpdate: "Confirm",
  userPicture: "Profile Photo",
  registrationEmail: "Email",
  pleaseFillOut: "Please Enter",
  cellPhone: "Mobile No.",
  memberName: "Username",
  memberNameEn: "Member Name(EN)",
  acceptInformation: "Receive House730 member newsletter (Email)",
  acceptSMS: "Receive House730 SMS",
  estateAgent: "Licensed property agent",
  estateAgentNotice: "If you are an property agent, please fill in the followings.",
  realEstateAgency: "Company name(Chi)",
  realEstateAgencyEN: "Company name(Eng)",
  realEstateAgencyPhone: "Company phone no.",
  realEstateAgencyAddress: "Company address",
  estateAgencyLicense: "Company License",
  personalAstateAgencyLicense: "Personal License",
  personalAgentSignature: "Property Agent Signature and Description",
  noUserName: 'Please fill in username',
  noCompanyName: 'Please fill in Company Name',
  noCompanyTelephone: 'Please fill in Company Phone no',
  telError: 'Invalid phone format',
  noCompanyAddress: 'Please fill in Company Address',
  noCompanyLicense: "Please fill in Company License",
  noLicense: 'Please fill in Personal License',
  signature: 'Proxy Personal Signature',
  fileError: 'Invalid Format,Only jpg, jpeg, png files are allowed',
  picfailure: 'Fail to upload profile pic',
  fileBig: 'File is too large,file size must be under 5MB',
  fileBig2: 'File is too small,file size must be above 20KB',
  editFailure: ' Edit Failure',
  login: "Login",
 },
}
export default language[type]